const resources = {
    textUs: 'Envoyez-nous un texto',
    agreeText: 'En communiquant avec nous par message texte, vous acceptez les',
    textTerms: 'CONDITIONS D’UTILISATION DE LA MESSAGERIE TEXTE',
    and: 'et',
    privacyPolicy: 'Politique de confidentialité',
    disclaimer: '. Des frais de messagerie texte et de données peuvent s’appliquer. La fréquence des messages peut varier. Répondez ARRET pour vous désinscrire ou AIDE pour obtenir de l’aide. Le numéro avec lequel Sephora communiquera avec vous est le ',
    representative: 'Des représentant(e)s sont disponibles :',
    monFri: 'Du lundi au vendredi',
    monFriTime: 'de 5 h à 21 h HP',
    satSun: 'Samedi et dimanche',
    satSunTime: 'de 6 h à 21 h HP'
};

export default function getResource(label) {
    return resources[label];
}
